<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h5>Ítems adicionales</h5>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <input-field
            v-show="editable"
            placeholder="Cód. Movimiento"
            id="referencia_movimiento"
            v-model="referencia_movimiento"
          ></input-field>
          <button
            v-show="editable"
            @click="consultarMovimiento"
            class="btn-success btn--text"
          >
            <i class="fa fa-download"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table>
        <thead>
          <tr>
            <th>Movimiento</th>
            <th>Cant. Ítems</th>
            <th>Fecha de asignación</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(movimiento, index) in movimientos" :key="movimiento.id">
            <td>
              {{ movimiento.referencia_movimiento }}
            </td>
            <td>
              {{ movimiento.cantidad_items }}
            </td>
            <td>
              {{ movimiento.created_at }}
            </td>
            <td>
              <button
                class="btn-info btn--text"
                type="button"
                @click="verItems(movimiento)"
              >
                <i class="fa fa-eye"></i>
              </button>
              <button
                v-show="editable"
                class="btn-danger btn--text"
                type="button"
                @click="quitarMovimiento(index)"
              >
                <i class="fa fa-times"></i>
              </button>
            </td>
          </tr>
          <tr v-show="movimientos.length === 0">
            <td colspan="4">
              <strong>No ha agregado movimientos adicionales.</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <modal
      adaptive
      reset
      resizable
      scrollable
      name="aceptarItemsAdicionales"
      height="auto"
      width="65%"
    >
      <aceptar-items-adicionales
        :items="itemsActuales"
        @aceptar="aceptarItems"
        @cancelar="$modal.hide('aceptarItemsAdicionales')"
      ></aceptar-items-adicionales>
    </modal>
    <modal
      adaptive
      reset
      resizable
      scrollable
      name="visorItemsAdicionales"
      height="auto"
      width="65%"
    >
      <visor-items-adicionales
        :items="itemsConsultados"
        @cerrar="$modal.hide('visorItemsAdicionales')"
      ></visor-items-adicionales>
    </modal>
  </div>
</template>

<script>
import AceptarItemsAdicionales from "./AceptarItemsAdicionales.vue";
import VisorItemsAdicionales from "./VisorItemsAdicionales.vue";
export default {
  components: {
    AceptarItemsAdicionales,
    VisorItemsAdicionales,
  },
  props: {
    ruta_id: {
      type: String,
      required: false,
      default: ''
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    visitaId: {
      type: String,
      required: false,
      default: "",
    },
    value: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      referencia_movimiento: "",
      movimientos: this.value,
      itemsActuales: [],
      itemsConsultados: [],
    };
  },
  methods: {
    consultarMovimiento: function () {
      axios
        .get(url + "/inventario/movimientos", {
          params: {
            referencia_movimiento: this.referencia_movimiento,
            tipo: "AV",
            ruta_id: this.ruta_id
          },
        })
        .then(({ data }) => {
          if (data.length === 0) {
            swal(
              "No se ha encontrado el movimiento indicado.",
              "Aviso",
              "warning"
            );
          } else {
            this.itemsActuales.splice(0, this.itemsActuales.length);
            for (let i = 0; i < data.length; i++) {
              this.itemsActuales.push({
                item_id: data[i].item_id,
                nombre_item: data[i].nombre,
                cantidad: data[i].cantidad,
                codigo_barra: data[i].codigo_barra,
              });
            }
            this.$modal.show("aceptarItemsAdicionales");
          }
        })
        .catch(({ response }) => {
          const { status, data: { errors } } = response;
          if (status === 409) {
            swal(
              "El movimiento ya ha sido referenciado con anterioridad.",
              "Aviso",
              "warning"
            );
            return;
          } 
          if (status === 422) 
            swal(errors.producto[0], "Aviso", "warning");
          else 
            swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    quitarMovimiento: function (index) {
      let movimiento = this.movimientos[index];
      swal({
        title: "¿Deseas quitar el movimiento?",
        text: "Se quitará el movimiento seleccionado",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/" + movimiento.id + "/items-movimiento-adicional", {
              _method: "DELETE",
            })
            .then(() => {
              swal(
                "El movimiento ha sido quitado exitósamente.",
                "Realizado",
                "success"
              );
              this.movimientos.splice(index, 1);
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    verItems: function (movimiento) {
      axios
        .get(url + "/" + movimiento.id + "/items-movimiento-adicional")
        .then(({ data }) => {
          this.itemsConsultados = data;
          this.$modal.show("visorItemsAdicionales");
        })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    aceptarItems: function (items) {
      axios
        .post(url + "/movimiento-adicional-visita", {
          referencia_movimiento: this.referencia_movimiento,
          visita_id: this.visitaId,
          items: items,
        })
        .then(({ data }) => {
          swal("El movimiento fue añadido con éxito.", "Realizado", "success");
          this.movimientos.push(data);
          this.referencia_movimiento = "";
          this.$modal.hide("aceptarItemsAdicionales");
        })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/visitas/ItemsAdicionales.vue